export default {
  path: '/',
  name: 'custom',
  component: () => import('@/layouts/BaseLayout'),
  children: [
    {
      path: 'custom',
      meta: { title: '客户列表', permission: 'custom' },
      component: () => import('@/views/custom/index'),
    },
    {
      path: 'custom-asset',
      meta: { title: '客户资金列表', permission: 'custom-asset' },
      component: () => import('@/views/custom/asset'),
    },
    {
      path: 'custom-trade',
      meta: { title: '客户交易记录', permission: 'custom-trade' },
      component: () => import('@/views/custom/trade'),
    },
  ],
}